import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/services";

const SectionHeading = ({ eyebrow, title, subtitle }) => (
  <div className="mx-auto max-w-2xl text-center">
    <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold">{eyebrow}</span>
    <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground text-balance sm:text-4xl">{title}</h2>
    {subtitle && (
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">{subtitle}</p>
    )}
  </div>
);

export const Services = () => {
  return (
    <section id="services" className="py-12 sm:py-20">
      <div className="container-nc">
        <SectionHeading
          eyebrow="What we do"
          title="Services under one system"
          subtitle="Every service below is planned, scoped and supervised by NC — so you deal with one responsible point of contact, not many contractors."
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.08, ease: "easeOut" }}
            >
              <Card className="group flex h-full flex-col p-5 shadow-card transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-elegant hover:border-gold/40 sm:p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-gold group-hover:text-gold-foreground sm:h-12 sm:w-12">
                  <service.icon className="h-6 w-6" />
                </span>
                <h3 className="mt-4 text-lg font-bold text-foreground sm:text-xl">{service.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
                  {service.description}
                </p>
                <Button
                  asChild
                  variant="link"
                  className="mt-auto h-auto justify-start p-0 pt-4 text-primary"
                >
                  <a href="#estimate">
                    Request this service <ArrowRight className="!size-4" />
                  </a>
                </Button>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
